const getElementCenter = (element: Element) => {
    const { top, left, width, height } = element.getBoundingClientRect();

    return {
        x: left + width / 2,
        y: top + height / 2,
    };
};

export { getElementCenter };
